<template>
  <v-card elevation="0" :color="showForm ? '#f4f4f4' : '#ffffff'" :class="type == 'selectToPackage' ? '' : 'px-4'">
    <v-divider></v-divider>

    <div :class="$vuetify.breakpoint.width >= 1000 ? 'd-flex justify-space-between mt-6' : 'd-flex flex-column mt-6'"
      v-if="!showForm">
      <div :class="$vuetify.breakpoint.width >= 1000 ? 'd-flex align-center' : 'd-flex flex-column mb-4'">
        <h1 :class="$vuetify.breakpoint.width >= 1000 ? 'mb-2 mr-4' : 'mb-3'"
          :style="$vuetify.breakpoint.width < 1000 ? 'font-size: 1.5rem;' : ''">Gestão de usuários</h1>
        <div :class="selectedProfileId ? '' : '--ballooom'">
          <span>
            <v-autocomplete v-model="selectedProfileId" :items="profileOptions" item-text="displayName"
              item-value="profileId" outlined dense clearable :loading="loadingProfiles" :disabled="loadingProfiles"
              placeholder="Selecione um perfil..."
              :style="$vuetify.breakpoint.width >= 1000 ? 'min-width: 370px; max-width: 470px' : 'width: 100%'"
              @change="onProfileChange" @input="onProfileInput" hide-details no-data-text="Nenhum perfil encontrado">
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.displayName }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </span>
          <div v-if="!selectedProfileId && !loadingProfiles">
            Selecione um perfil para listar os usuários associados a ele
          </div>
        </div>
      </div>

      <div :class="$vuetify.breakpoint.width >= 1000 ? 'd-flex align-center' : 'd-flex flex-column'"
        v-if="type !== 'selectToPackage'">


        <v-btn @click="addUser()" style="color: white"
          :class="$vuetify.breakpoint.width >= 1000 ? 'py-5 mr-3 mb-1' : 'py-5 mb-3'" color="#33477f" elevation="0"
          :block="$vuetify.breakpoint.width < 1000">Cadastrar novo usuário</v-btn>

        <v-text-field :style="$vuetify.breakpoint.width >= 1000 ? 'width: 445px' : 'width: 100%'" v-model="search"
          append-icon="mdi-magnify" outlined label="Buscar (Nome, e-mail, telefone ou setor)" single-line dense
          hide-details></v-text-field>


      </div>
    </div>
    <div>
    </div>
    <v-card outlined v-if="!showForm">
      <v-data-table :dense="type == 'selectToPackage'" :class="type == 'selectToPackage' ? 'dense-table' : ''"
        :headers="headers" :items="filteredUsers" :items-per-page="type == 'selectToPackage' ? 5 : 10" :sort-by="sortBy"
        :sort-desc="sortDesc" :loading="loading" :mobile-breakpoint="0" class="elevation-1">

        <template v-slot:[`item.contacts`]="{ item }">
          <div class="text-center">
            <span>{{ getPhoneContact(item.contacts).display }}</span>
            <v-tooltip bottom v-if="getPhoneContact(item.contacts).hasMore">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="ml-1 primary--text" style="cursor: pointer;">
                  +{{ getPhoneContact(item.contacts).additionalCount }}
                </span>
              </template>
              <div>
                <div v-for="(phone, index) in getPhoneContact(item.contacts).additionalPhones" :key="index">
                  {{ phone.contactTypeDescription }}: {{ phone.contact }}
                </div>
              </div>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:[`item.userJob`]="{ item }">
          <div class="text-center">
            {{ item.userJob || '-' }}
          </div>
        </template>

        <template v-slot:[`item.userInfo`]="{ item }">
          <div class="text-center">
            {{ item.userInfo || '-' }}
          </div>
        </template>

        <template v-slot:[`item.createdOn`]="{ item }">
          <div class="text-center">
            {{ formatDate(item.createdOn) }}
          </div>
        </template>

        <template v-slot:[`item.typeDc`]="{ item }">
          <div class="text-center">
            {{ translateSector(item.typeId) }}
          </div>
        </template>

        <template v-slot:[`item.userStatusId`]="{ item }">
          <div class="text-center">
            <v-chip :color="item.userStatusId == 1 ? 'green' : 'red'" text-color="white" small>
              <strong>{{ item.userStatusId == 1 ? 'Ativo' : 'Inativo' }}</strong>
            </v-chip>
          </div>
        </template>

        <template v-slot:[`item.isDefault`]="{ item }">
          <div class="text-center">
            <v-checkbox
              :input-value="item.isDefault == true || item.isDefault == 1"
              @click.native="handleDefaultProfileChange(item)"
              readonly
              hide-details
              class="mt-0 pt-0"
              style="display: inline-flex; justify-content: center;"
            ></v-checkbox>
          </div>
        </template>

        <template v-slot:[`item.mais`]="{ item }">
          <div class="text-center d-flex justify-center align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="editUser(item)" class="mr-2">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-switch
                    v-model="item.assocStatusId"
                    :true-value="'1'"
                    :false-value="'2'"
                    inset
                    dense
                    hide-details
                    :class="['mt-0', 'user-status-switch', item.assocStatusId === '2' ? 'switch-inactive' : 'switch-active']"
                    @change="confirmToggleStatus(item)"
                    :disabled="isCurrentUser(item)"
                    color="success"
                  ></v-switch>
                </div>
              </template>
              <span>{{ isCurrentUser(item) ? 'Não é possível alterar seu próprio status' : (item.assocStatusId === '2' ? 'Associar novamente' : 'Desassociar usuário') }}</span>
            </v-tooltip>
          </div>
        </template>

      </v-data-table>

    </v-card>

    <EditUserDialog :isEditUser.sync="isEditUserDialog" :currentUser="selectedUser" @userUpdated="onUserUpdated" />

    <AddUserDialog :isAddUser.sync="isAddUserDialog" @userCreated="onUserCreated" />


    <v-dialog v-model="deleteAccessDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          Confirmação
        </v-card-title>
        <v-card-text>
          <span v-if="actionType === 'detach'">
            Tem certeza que deseja desativar o acesso de <strong>{{ selectedUserForDelete?.userName }}</strong> do perfil
            <strong>{{ selectedUserForDelete?.profileDisplayName }}</strong>?
          </span>
          <span v-else>
            Tem certeza que deseja ativar o acesso de <strong>{{ selectedUserForDelete?.userName }}</strong> no perfil
            <strong>{{ selectedUserForDelete?.profileDisplayName }}</strong>?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cancelToggleStatus">
            Cancelar
          </v-btn>
          <v-btn :loading="loadingDeleteUser" color="primary" @click="deleteUserAccess">
            Sim, continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="isDefaultConfirmation" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">
          Alterar Perfil Principal
        </v-card-title>
        <v-card-text>
          Deseja definir este como o perfil principal de <strong>{{ itemToSetDefault?.userName }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="isDefaultConfirmation = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" dark :loading="loadingSetDefault" @click="confirmSetDefaultProfile">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="showSnackbarSuccess" :timeout="2000" color="success" top>
      {{ messageSuccessSnackbar }}
    </v-snackbar>

    <v-snackbar v-model="showSnackbarError" :timeout="2000" color="red" top>
      {{ messageErrorSnackbar }}
    </v-snackbar>
  </v-card>
</template>

<script>
import EditUserDialog from './EditUserDialog.vue';
import AddUserDialog from './AddUserDialog.vue';
import { getAuth } from '@/services/authService'

export default {
  name: 'UsersList',

  components: {
    EditUserDialog,
    AddUserDialog
  },

  data() {
    return {
      get auth() {
        return getAuth()
      },

      loadingDeleteUser: false,
      loadingProfiles: false,
      headers: [
        {
          text: "Perfil Principal",
          value: "isDefault",
          align: "center",
          sortable: false,
        },
        {
          text: "Nome",
          value: "userName",
          sortable: false,
        },
        {
          text: "Telefone",
          value: "contacts",
          align: "center",
          sortable: false,
        },
        {
          text: "E-mail",
          value: "userEmail",
          sortable: false,
        },
        {
          text: "Setor",
          value: "typeDc",
          align: "center",
          sortable: false,
        },
        {
          text: "Cargo",
          value: "userJob",
          align: "center",
          sortable: false,
        },
        {
          text: "Vínculo de atendimento",
          value: "userInfo",
          align: "center",
          sortable: false,
        },
        {
          text: "Cadastro",
          value: "createdOn",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "mais",
          sortable: false,
        },
      ],
      users: [],
      loading: false,
      search: "",
      sortBy: "userName",
      sortDesc: false,
      showForm: false,
      type: "normal",
      isEditUserDialog: false,
      selectedUser: null,
      isAddUserDialog: false,
      deleteAccessDialog: false,
      selectedUserForDelete: null,
      actionType: 'detach',
      isDefaultConfirmation: false,
      itemToSetDefault: null,
      loadingSetDefault: false,
      showSnackbarSuccess: false,
      messageSuccessSnackbar: "",
      showSnackbarError: false,
      messageErrorSnackbar: "",
      selectedProfileId: null,
      profileOptions: []
    }
  },
  computed: {
    filteredUsers() {
      if (!this.search) {
        return this.users;
      }

      const searchTerm = this.search.toLowerCase();

      return this.users.filter(user => {
        const matchId = user.id && user.id.toString().toLowerCase().includes(searchTerm);

        const matchName = user.userName && user.userName.toLowerCase().includes(searchTerm);

        const matchEmail = user.userEmail && user.userEmail.toLowerCase().includes(searchTerm);


        const phoneData = this.getPhoneContact(user.contacts);
        const matchPhone = phoneData.display && phoneData.display.toLowerCase().includes(searchTerm);


        const matchAdditionalPhones = phoneData.additionalPhones &&
          phoneData.additionalPhones.some(phone =>
            phone.contact && phone.contact.toLowerCase().includes(searchTerm)
          );

        const sectorName = this.translateSector(user.typeId);
        const matchSector = sectorName && sectorName.toLowerCase().includes(searchTerm);

        return matchId || matchName || matchEmail || matchPhone || matchAdditionalPhones || matchSector;
      });
    }
  },
  mounted() {
    this.loadProfiles();
  },

  methods: {
    async loadProfiles() {
      try {
        this.loadingProfiles = true;
        const response = await this.$axios.get(`profiles`);

        if (response.data && response.data.data) {
          const profilesData = response.data.data;

          this.profileOptions = Object.keys(profilesData)
            .map(key => profilesData[key])
            .filter(profile => profile.profileType === 2);

          if (this.profileOptions.length === 1) {
            this.selectedProfileId = this.profileOptions[0].profileId;
            this.$nextTick(() => {
              this.getUserAssoc();
            });
          }
        }
      } catch (error) {
        console.error('Erro ao carregar perfis:', error);
        this.messageErrorSnackbar = "Erro ao carregar perfis!";
        this.showSnackbarError = true;
      } finally {
        this.loadingProfiles = false;
      }
    },

    getUserAssoc() {

      if (!this.selectedProfileId) {
        this.users = [];
        return;
      }

      this.users = [];
      this.loading = true;

      const profileId = this.selectedProfileId;

      this.$axios
        .get(`profiles/admin/assoc/profile/${profileId}?model=1&mv`)
        .then((data) => {
          const usersAssoc = data.data.data;
          this.users = usersAssoc;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    accessTypeTxt(accessType) {
      let accessTypeTxt = "";

      switch (accessType) {
        case "Adminstrator":
          accessTypeTxt = "Admin";
          break;
        case "Commercial":
          accessTypeTxt = "Comercial";
          break;
        case "Marketing":
          accessTypeTxt = "Marketing";
          break;
        case "Financial":
          accessTypeTxt = "Financeiro";
          break;
        case "Creative":
          accessTypeTxt = "Criativo";
          break;
        case "OPEC":
          accessTypeTxt = "OPEC";
          break;
        default:
          accessTypeTxt = accessType || "";
          break;
      }

      return accessTypeTxt;
    },

    transformIntoPhoneType(contactTypeId) {
      let phoneTypeString = "";

      switch (contactTypeId) {
        case 2:
          phoneTypeString = "Telefone Fixo"
          break;
        case 8:
          phoneTypeString = "Celular"
          break;
        case 9:
          phoneTypeString = "Whatsapp"
          break;
        default:
          phoneTypeString = "Contato";
          break;
      }

      return phoneTypeString;
    },

    getFilteredContact(contacts) {
      if (!contacts || contacts.length === 0) {
        return { contact: null, phoneType: "" };
      }

      let contact = contacts.find(contact => contact.contactTypeId !== 1);

      if (!contact) {
        contact = contacts[0];
      }

      const phoneTypeNumber = contact?.contactTypeId;
      contact = { ...contact, phoneType: this.transformIntoPhoneType(phoneTypeNumber) };

      return contact;
    },

    getPhoneContact(contacts) {
      if (!contacts || contacts.length === 0) {
        return {
          display: '-',
          hasMore: false,
          additionalCount: 0,
          additionalPhones: []
        };
      }


      const phoneContacts = contacts.filter(contact =>
        contact.contactTypeId === 8 || contact.contactTypeId === 2 || contact.contactTypeId === 9
      );

      if (phoneContacts.length === 0) {
        return {
          display: '-',
          hasMore: false,
          additionalCount: 0,
          additionalPhones: []
        };
      }


      const primaryPhone = phoneContacts[0];
      const phoneTypeString = this.transformIntoPhoneType(primaryPhone.contactTypeId);
      const display = `${phoneTypeString}: ${primaryPhone.contact}`;


      const additionalPhones = phoneContacts.slice(1).map(phone => ({
        ...phone,
        contactTypeDescription: this.transformIntoPhoneType(phone.contactTypeId)
      }));
      const hasMore = additionalPhones.length > 0;
      const additionalCount = additionalPhones.length;

      return {
        display,
        hasMore,
        additionalCount,
        additionalPhones
      };
    },

    formatDate(dateString) {
      if (!dateString) return '-';


      const [datePart, timePart] = dateString.split(' ');
      const [year, month, day] = datePart.split('-');

      const monthNames = [
        'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
        'jul', 'ago', 'set', 'out', 'nov', 'dez'
      ];

      const monthName = monthNames[parseInt(month) - 1];

      return `${parseInt(day)} de ${monthName} de ${year}`;
    },

    translateSector(typeId) {
      const sectorMap = {
        1: 'Administrador',
        2: 'Moderador',
        3: 'Comercial',
        4: 'Marketing',
        5: 'Financeiro',
        6: 'Agência',
        7: 'Representante Legal',
        8: 'Acesso Básico',
        9: 'Criativo',
        10: 'OPEC'
      };

      return sectorMap[parseInt(typeId)] || 'Não definido';
    },

    editUser(item) {
      this.selectedUser = item;
      this.isEditUserDialog = true;
    },

    addUser() {
      this.isAddUserDialog = true;
    },

    onUserUpdated() {

      this.getUserAssoc();
    },

    onUserCreated() {

      this.getUserAssoc();
    },

    confirmToggleStatus(user) {
      this.actionType = user.assocStatusId === '1' ? 'attach' : 'detach';
      this.selectedUserForDelete = user;
      this.deleteAccessDialog = true;
    },

    async deleteUserAccess() {
      this.loadingDeleteUser = true;

      if (this.actionType === 'detach') {
        
        const urlToDetachUserFromProfile = "publisherportal/assoc";

        const userData = {
          id: this.selectedUserForDelete.id,
          userId: parseInt(this.selectedUserForDelete.userId),
          profileId: parseInt(this.selectedProfileId),
          action: "detach",
          mv: true,
          userName: this.selectedUserForDelete.userName,
          userEmail: this.selectedUserForDelete.userEmail,
          userPhone: this.selectedUserForDelete.userPhone,
          userSector: this.selectedUserForDelete.typeId,
          userInfo: this.selectedUserForDelete.userInfo
        };

        await this.$axios
          .post(urlToDetachUserFromProfile, userData)
          .then(() => {
            this.messageSuccessSnackbar = "Usuário desativado!";
            this.showSnackbarSuccess = true;

            this.getUserAssoc();

            setTimeout(() => {
              this.deleteAccessDialog = false;
              this.selectedUserForDelete = null;
            }, 1500);
          })
          .catch(() => {
            this.messageErrorSnackbar = "Erro ao desativar usuário!";
            this.showSnackbarError = true;
            
            this.selectedUserForDelete.assocStatusId = this.selectedUserForDelete.assocStatusId === '1' ? '2' : '1';
          })
          .finally(() => {
            this.loadingDeleteUser = false;
          });
      } else {
        await this.$axios
          .put('/profiles/admin/assoc/reactivate', {
            userId: parseInt(this.selectedUserForDelete.userId),
            profileId: parseInt(this.selectedProfileId)
          })
          .then(() => {
            this.messageSuccessSnackbar = "Usuário ativado!";
            this.showSnackbarSuccess = true;

            this.getUserAssoc();

            setTimeout(() => {
              this.deleteAccessDialog = false;
              this.selectedUserForDelete = null;
            }, 1500);
          })
          .catch(() => {
            this.messageErrorSnackbar = "Erro ao ativar usuário!";
            this.showSnackbarError = true;
            
            this.selectedUserForDelete.assocStatusId = this.selectedUserForDelete.assocStatusId === '1' ? '2' : '1';
          })
          .finally(() => {
            this.loadingDeleteUser = false;
          });
      }
    },

    onProfileChange() {
      if (this.selectedProfileId) {
        this.getUserAssoc();
      } else {

        this.users = [];
      }
    },

    onProfileInput(value) {

      if (!value) {
        this.users = [];
      }
    },

    isCurrentUser(item) {
      if (!this.auth || !this.auth.user) return false;

      return this.auth.user.email === item.userEmail;
    },

    cancelToggleStatus() {
      
      if (this.selectedUserForDelete) {
        this.selectedUserForDelete.assocStatusId = this.selectedUserForDelete.assocStatusId === '1' ? '2' : '1';
      }
      this.deleteAccessDialog = false;
      this.selectedUserForDelete = null;
    },

    handleDefaultProfileChange(item) {
      if (item.isDefault == true || item.isDefault == 1) {
        return;
      }
      this.itemToSetDefault = item;
      this.isDefaultConfirmation = true;
    },

    async confirmSetDefaultProfile() {
      try {
        this.loadingSetDefault = true;
        await this.$axios.put('/profiles/admin/default', {
          profileId: this.selectedProfileId,
          userId: this.itemToSetDefault.userId
        });
        this.messageSuccessSnackbar = "Perfil principal atualizado!";
        this.showSnackbarSuccess = true;
        this.isDefaultConfirmation = false;
        this.itemToSetDefault = null;
        this.getUserAssoc();
      } catch (error) {
        this.messageErrorSnackbar = "Erro ao atualizar perfil principal!";
        this.showSnackbarError = true;
      } finally {
        this.loadingSetDefault = false;
      }
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: 'Roboto', sans-serif !important;
}

.theme--light.v-sheet {
  border-color: rgb(168, 168, 168) !important;
}

.dense-table {

  th,
  td {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

.--ballooom {
  position: relative;

  >div {
    background: #33477f;
    color: #fff;
    padding: 9px 15px;
    border-radius: 3px;
    position: absolute;
    z-index: 1;
    top: 30px;
    margin: 10px 10px 0;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .3);

    &:after {
      border-color: rgba(136, 183, 213, 0) !important;
      border-bottom-color: #33477f !important;
      border-width: 10px !important;
      margin-left: -30px !important;
      bottom: 100% !important;
      left: 100%;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

  }

  >span {}
}

.user-status-switch {
  &.v-input--is-disabled {
    opacity: 0.6;
  }
}

.switch-inactive.v-input--switch--inset {
  .v-input--switch__track {
    background-color: #ef5350 !important;
    opacity: 1 !important;
  }
  .v-input--selection-controls__ripple,
  .v-input--switch__thumb {
    color: #fff !important;
    background-color: #fff !important;
    caret-color: #fff !important;
  }
}

.switch-active.v-input--switch--inset {
  .v-input--switch__track {
    background-color: #4caf50 !important;
    opacity: 1 !important;
  }
  .v-input--selection-controls__ripple,
  .v-input--switch__thumb {
    color: #fff !important;
    background-color: #fff !important;
    caret-color: #fff !important;
  }
}
</style>